import React from "react";
import Tooltip from "@mui/material/Tooltip";
import color from "../../../../../../constants/color";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";
import { formatPhoneNumber } from "../../constants";

interface Props {
  item: Lead;
  // Click no ÍCONE → ação principal (abre modal se conectado, copia se não).
  onWhatsAppClick: (item: Lead) => void;
  // Click na LABEL DO NÚMERO → sempre copia.
  onWhatsAppCopyPhone: (item: Lead) => void;
  // Usado para escolher o tooltip do ícone.
  isWhatsConnected?: boolean;
  unreadCount?: number;
}

const getPhoneData = (item: Lead) => {
  const phones = [item.telefone1, item.telefone2, item.telefone3];
  const phonePrincipal = phones[(item.codigoTelefonePrincipal || 1) - 1];
  const formattedPhone = formatPhoneNumber(phonePrincipal || "");

  const phoneLink = (() => {
    switch (item.codigoTelefonePrincipal) {
      case 1:
        return item.telefone1;
      case 2:
        return item.telefone2;
      case 3:
        return item.telefone3;
      default:
        return item.telefone1;
    }
  })();

  return { formattedPhone, phoneLink };
};

const baseBtnStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  font: "inherit",
};

export const PhoneCell: React.FC<Props> = ({
  item,
  onWhatsAppClick,
  onWhatsAppCopyPhone,
  isWhatsConnected = false,
  unreadCount = 0,
}) => {
  const { formattedPhone } = getPhoneData(item);
  const unreadLabel = unreadCount > 99 ? "99+" : unreadCount;
  const iconTooltip = isWhatsConnected
    ? "Abrir conversa do WhatsApp"
    : "Abrir no WhatsApp";

  return (
    <Styles.Td
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip",
        maxWidth: "unset",
        width: "1%",
        paddingRight: 12,
      }}
    >
      <Tooltip followCursor title={iconTooltip} placement="top-start" arrow>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onWhatsAppClick(item);
          }}
          style={{ ...baseBtnStyle, marginRight: 4 }}
          aria-label="Abrir conversa do WhatsApp"
        >
          <span style={{ position: "relative" }}>
            <i
              style={{
                backgroundColor: color.Success,
                borderRadius: 30,
                color: "white",
                padding: 2,
              }}
              className="lab la-whatsapp la-1x"
            />
            {unreadCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -7,
                  right: -9,
                  minWidth: 16,
                  height: 16,
                  borderRadius: 8,
                  background: "#25D366",
                  color: "#FFFFFF",
                  fontSize: 9,
                  lineHeight: "16px",
                  textAlign: "center",
                  padding: "0 3px",
                  fontWeight: 700,
                  boxShadow: "0 0 0 2px #fff",
                }}
              >
                {unreadLabel}
              </span>
            )}
          </span>
        </button>
      </Tooltip>
      <Tooltip
        followCursor
        title={formattedPhone ? "Copiar número" : "Sem informação do telefone"}
        placement="top-start"
        arrow
      >
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onWhatsAppCopyPhone(item);
          }}
          style={baseBtnStyle}
          aria-label="Copiar número"
        >
          {formattedPhone || "--"}
        </button>
      </Tooltip>
    </Styles.Td>
  );
};
